import { useEffect, useState } from 'react';

export function useLoginUrl() {
    const [loginUrl, setLoginUrl] = useState('/accounts/non-private/sign-in');

    useEffect(() => {
        const loc = (window.location.pathname + window.location.search).slice(1);
        setLoginUrl(`/accounts/non-private/sign-in?returnUrl=${encodeURIComponent(loc)}`);
    }, []);

    return loginUrl;
}
